import { useState } from "react";
import {
    Box,
    Paper,
    Typography,
    ListItem,
    ListItemButton,
    ListItemText,
    FormControl,
    Select,
    MenuItem,
    InputLabel
} from "@mui/material";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import JobProfileForm from "./JobProfileForm";
import { createJobProfile, updateJobProfile, deleteJobProfile, requestJobProfiles } from "../../../remote/jobProfilesRequest";
import theme from "../../../components/LayoutComponents/theme";




export default function JobProfiles({ session, jobProfiles, setJobProfiles, companies, skillProfiles }) {

    const [selected, setSelected] = useState(null);
    const [selectedSkillProfile, setselectedSkillProfile] = useState("")
    const [selectedSchool, setSelectedSchool] = useState("")


    const initialFormData = {
        profileId: 0,
        profileName: "",
        summary: "",
        location: "",
        employmentType: "",
        seniorityLevel: "",
        industryId: null,
        dutiesResponsibilities: "",
        requiredEducation: "",
        requiredExperience: "",
        requiredCertificates: "",
        requiredOther: "",
        preferredQualifications: "",
        workEnvironment: "",
        physicalDemands: "",
        benefits: "",
        additionalInformation: "",
        linkAdditionalInformation: "",
        linkApply: "",
        effectiveStartDate: null,
        effectiveEndDate: null,
        activeFlag: false,
        entityId: null,
        templateId: null,
        payMin: null,
        payMax: null,
        payType: null,
        owner: session.username+" - "+session.name,
    };
    const [formData, setFormData] = useState(initialFormData)
    const [loading, setLoading] = useState(false)

    const handleSave = async () => {
        let resTemp;
        try {
            setLoading(true)
            if (formData?.profileId === 0) {
                resTemp = await createJobProfile(session?.token, formData);
                setJobProfiles((prev) => [resTemp.data, ...prev]);
            } else {
                await updateJobProfile(session?.token, formData);
                let res = await requestJobProfiles(session?.token)
                setJobProfiles(res.data||[])
            }
        } catch (err) {
            console.error("Error saving job profile", err);
        } finally {
            setLoading(false)
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true)
            let res = await deleteJobProfile(session?.token, selected?.profileId)
            setJobProfiles(res.data || []);
            setSelected(null);
            setFormData(initialFormData);
        } catch (err) {
            console.error("Error deleting job profile", err);
        } finally {
            setLoading(false)
        }
    }



    return (
        <Box sx={{ display: "flex", gap: 3, width: "100%", alignItems: "flex-start" }}>
            <Paper
                sx={{
                    width: "25%",
                    p: 2,
                    height: "60vh",
                    overflowY: "auto",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ mb: 2, color: theme.colors.purple, textAlign: "center" }}
                >
                    Job Profiles
                </Typography>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Filter by Company</InputLabel>
                    <Select
                        value={selectedSchool ?? ""}
                        label="Filter by Company"
                        onChange={(e) => setSelectedSchool(Number(e.target.value))}
                    >
                        <MenuItem value="">All</MenuItem>
                        {companies.map((company) => (
                            <MenuItem key={company.entityId} value={company.entityId}>
                                {company.entityName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Filter by Skill Profile</InputLabel>
                    <Select
                        value={selectedSkillProfile ?? ""}
                        label="Filter by Skill Profile"
                        onChange={(e) => setselectedSkillProfile(Number(e.target.value))}
                    >
                        <MenuItem value="">All</MenuItem>
                        {skillProfiles?.map((profile) => (
                            <MenuItem key={profile.profileId} value={profile.profileId}>
                                {profile.profileName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {jobProfiles?.length > 0 || !loading ?
                    jobProfiles
                        ?.filter(t => !selectedSkillProfile || t.templateId === selectedSkillProfile)
                        ?.filter(t => !selectedSchool || t.entityId === selectedSchool)
                        ?.sort((a, b) => a.profileName.toLowerCase().localeCompare(b.profileName.toLowerCase()))                        
                        .map((profile) => (
                            <ListItem key={profile.profileId} disablePadding>
                                <ListItemButton
                                    selected={selected?.profileId === profile.profileId}
                                    onClick={() => {
                                        setSelected(profile);
                                        setFormData(profile);
                                    }}
                                >
                                    <ListItemText primary={profile?.profileName} />
                                </ListItemButton>
                            </ListItem>
                        )) : <LoadingCircle size={20} />}
            </Paper>
            <Box sx={{ flex: 1, minWidth: 600 }}>
                <JobProfileForm
                    onSave={handleSave}
                    onDelete={handleDelete}
                    session={session}
                    formData={formData}
                    setFormData={setFormData}
                    loading={loading}
                    companies={companies}
                    skillProfiles={skillProfiles}
                />
            </Box>
        </Box>
    )
}
